/**
 * Waits for Adobe Analytics (_satellite) to be available.
 * Used to prevent race conditions when analytics events fire before Adobe Launch loads.
 *
 * @param timeout - Maximum time to wait in milliseconds (default: 5000ms)
 * @param interval - Polling interval in milliseconds (default: 100ms)
 * @returns Promise that resolves when _satellite is available or rejects on timeout
 */
export const waitForAdobeAnalytics = (
  timeout = 5000,
  interval = 100,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkSatellite = () => {
      // Check if Adobe Launch's _satellite object is available
      // eslint-disable-next-line no-underscore-dangle
      if (window._satellite) {
        resolve();
        return;
      }

      // Check if we've exceeded the timeout
      if (Date.now() - startTime >= timeout) {
        reject(new Error('Adobe Analytics (_satellite) failed to load within timeout'));
        return;
      }

      // Continue polling
      setTimeout(checkSatellite, interval);
    };

    checkSatellite();
  });
};
